export default __webpack_public_path__ + "static/media/ky.d1b411ec.svg";